import React, { type CSSProperties, useMemo } from "react";
import "./styles.scss";
import { buildCls } from "../../../utils/helpers/buildCls";

export interface HeadingProps {
  id?: string;
  text?: string | number | React.ReactNode;
  primary?: boolean;
  secondary?: boolean;
  className?: string;
  style?: CSSProperties;
}

export default function KC_Heading0(props: HeadingProps) {
  const className = useMemo(() => {
    const cls = [
      "kc-heading",
      "kc-heading-0",
      props.className ?? "",
      props.primary ? "text-blue" : "",
      props.secondary ? "text-secondary" : ""
    ];
    return buildCls(cls);
  }, [props.primary, props.secondary, props.className]);

  return (
    <h1 id={props.id} className={className} style={props.style}>
      {props.text}
    </h1>
  );
}
